class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.selectedIndex = -1;

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    
    this.input.addEventListener('keydown', this.onKeydown.bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    this.selectedIndex = -1;

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onKeydown(event) {
    const activeSection = this.predictiveSearchResults.querySelector('.search-results-section.active');
    const selectables = activeSection ? activeSection.querySelectorAll('a') : this.predictiveSearchResults.querySelectorAll('a');
    
    switch(event.code) {
      case 'ArrowDown':
        event.preventDefault();
        this.selectedIndex = Math.min(this.selectedIndex + 1, selectables.length - 1);
        this.updateSelection(selectables);
        break;
      case 'ArrowUp':
        event.preventDefault();
        this.selectedIndex = Math.max(this.selectedIndex - 1, -1);
        this.updateSelection(selectables);
        break;
      case 'Enter':
        if (this.selectedIndex >= 0 && selectables[this.selectedIndex]) {
          selectables[this.selectedIndex].click();
        }
        break;
      case 'Escape':
        this.close();
        break;
    }
  }

  updateSelection(selectables) {
    selectables.forEach((item, index) => {
      if (index === this.selectedIndex) {
        item.style.backgroundColor = '#e9ecef';
        item.setAttribute('aria-selected', 'true');
      } else {
        item.style.backgroundColor = '';
        item.setAttribute('aria-selected', 'false');
      }
    });
  }

  initializeTabs() {
    const tabs = this.predictiveSearchResults.querySelectorAll('.searchTab');
    const sections = this.predictiveSearchResults.querySelectorAll('.search-results-section');

    tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        const targetTab = e.target.dataset.tab;
        
        // Update tab states
        tabs.forEach(t => {
          t.classList.remove('activeTab');
          t.classList.add('inactiveTab');
        });
        e.target.classList.add('activeTab');
        e.target.classList.remove('inactiveTab');

        // Update section visibility
        sections.forEach(section => {
          section.classList.remove('active');
        });
        
        const targetSection = this.predictiveSearchResults.querySelector(`#${targetTab}-results`);
        if (targetSection) {
          targetSection.classList.add('active');
        }

        // Reset selection when switching tabs
        this.selectedIndex = -1;
        const selectables = targetSection ? targetSection.querySelectorAll('a') : [];
        this.updateSelection(selectables);
      });
    });
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.selectedIndex = -1;
        if (resultsMarkup.includes('predResultTitle') || resultsMarkup.includes('predictive-search-queries')){
          this.open();
          this.initializeTabs();
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {

    this.predictiveSearchResults.style.display = 'block';

    
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);


document.addEventListener('keydown', function(event) {


  if ((event.ctrlKey || event.metaKey) && event.key === 'k') {
        event.preventDefault(); // Prevent default browser behavior
        
        const searchInput = document.getElementById('nav-search-input');
        if (searchInput) {
            searchInput.focus();
        }
    }
});

function logSearch(loc){
    const tracking_url = "https://apiapi.ombligo.com/tracking";
    if (localStorage.getItem('id') === null) {
        const alphabet = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
        let identity = '';

        for (let i = 0; i < 8; i++) {
            identity += alphabet.charAt(Math.floor(Math.random() * alphabet.length)) ;
        }
        identity += 'cl';
        localStorage.setItem('id', identity);
    }
    const data = {
        identity: localStorage.getItem('id'),
        pageType: loc,
        page: document.getElementById('nav-search-input').value
    };

    fetch(tracking_url, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
}